import { Injectable } from "@angular/core";

import { Router } from "@angular/router";
import { HttpService } from "./http.service";
import { UserInfo } from "../security/user-info";
import { BehaviorSubject, tap } from "rxjs";

@Injectable()
export class UserService{

    public roles: string[] | null = null;
    public exp: string | null = null;
    public userName: string | null = null;

    private userInfoSubject = new BehaviorSubject<any>(null);

    constructor(
        private router: Router,
        private httpService: HttpService
    ){}

    updateUserInfo(){
        return this.httpService.getUserInfo().pipe(tap(res => {
                let userInfo = res as UserInfo;
                this.roles = userInfo.roles;
                this.userName = userInfo.username;
        }, error => console.error(error)));
    }

    isConnected(){
        let isConnected = localStorage.getItem("isConnected");
        if(isConnected && isConnected === "true"){
            return true;
        }
        return false;
    }

    getUserInfo(){
        return this.userInfoSubject.value;
    }

    hasRole(roleName: string){
        if(!this.roles){
            return false;
        }
        for(let role of this.roles){
            if(role == roleName){
                return true;
            }
        }
        return false;
    }

    hasAnyRole(roleNames: string[]){
        if(!this.roles){
            return false;
        }
        for(let role of this.roles){
            for(let roleName of roleNames){
                if(role == roleName){
                    return true;
                }
            }
        }
        return false;
    }

    isNot(roleName: string){
        if(!this.roles){
            return true;
        }
        for(let role of this.roles){
            if(role == roleName){
                return false;
            }
        }
        return true;
    }
    isNotAnyOf(roleNames: string[]){
        if(!this.roles){
            return true;
        }
        for(let role of this.roles){
            for(let roleName of roleNames){
                if(role == roleName){
                    return false;
                }
            }
        }
        return true;
    }

}